<template>
  <div class="container">
    <div class="header" :class="{folded: folded}" @click="toggleFolded">{{title}}</div>
    <div class="content" :class="{folded: folded}">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String
    },
    index: {
      type: Number,
      default: -1
    }
  },
  data () {
    return {
      folded: true
    }
  },
  methods: {
    toggleFolded () {
      this.folded = !this.folded;
      this.$emit('toggleFolded', this.folded, this.index);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 620px;
  margin-top: 4px;

  &:first-child {
    margin-top: 0;
  }
}
.header {
  width: 620px;
	height: 42px;
  line-height: 42px;
	background-color: #5778fb;
  color: #fff;
	border-radius: 4px 4px 0 0;
  cursor: pointer;

  &:hover {
      background-color: #5656e8;
    }

  &.folded {
    background-color: #d9ddea;
    color: #474261;
    border-radius: 4px;

    &:hover {
      background-color: #dfdfe7;
    }
  }
}

.content {
  height: 520px;
  background-color: #ffffff;
	border-radius: 0 0 4px 4px;
	border: solid 1px #d9ddea;
  // outline-top-width: 0;
  // outline-top-style: none;
  overflow: hidden;
  transition-duration: 0.2s;

  &.folded {
    height: 0;
    border-width: 0;
    outline: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/emodal/wordCloud/folder.vue